import { useCallback, useSyncExternalStore } from 'react';

import type { ExternalStore, Unsubscribe } from '@/types/common';

/**
 * A page-scoped store's snapshot, kept current. The store's methods are bound here because
 * React calls what it is handed as bare functions, and keeps the subscription only while the
 * function it was handed stays the same.
 */
export function useExternalStore<T>(store: ExternalStore<T>): T {
    const subscribe = useCallback(
        (listener: () => void): Unsubscribe => store.subscribe(listener), [store],
    );
    const getSnapshot = useCallback((): T => store.getSnapshot(), [store]);
    return useSyncExternalStore(subscribe, getSnapshot);
}
